// The Due Diligence face. That module was rebuilt from the original Cognito form and set its own
// type to match it; SLF Property's own bar and the desk toolbars follow it (owner 2026-09-25:
// 字体全部按照 Due Diligence 里的字体来显示), so the constant lives here and everyone reads the same
// one instead of each file carrying its own copy of the stack.
//
// public/index.html loads Roboto Condensed at weights 400 and 700 only — a 600 in a style here
// renders as 700, which is what Due Diligence's own chips already do.
export const RC = "'Roboto Condensed', Helvetica, Arial, sans-serif";

// The rule that makes a whole console inherit it. Form controls have to be named: buttons, inputs,
// selects and textareas do not inherit font-family. Icons are unaffected — `.ti` matches the <i>
// itself, and a rule that matches an element always beats a value inherited from its parent.
// Scoped by class rather than added to global.css, which is kept identical across two repositories.
export const rcScope = (cls: string) =>
  `.${cls}, .${cls} button, .${cls} input, .${cls} select, .${cls} textarea { font-family: ${RC}; }`;
